<script>
  export let env;
</script>

<main>
	<h1>Home from {env.name} on {env.backend}!</h1>
</main>
